import axios from "axios";
import { baseUrl } from "../Base_url";

export const getAssignedLaunchForStudent = async (token, page,limit,orderBy,order,data) => {
    try {
        const res = await axios.get(`${baseUrl}/student/launchtrek/fetchDataStudent?page=${page}&limit=${limit}&orderBy=${orderBy}&order=${order}&id=${data}`,{
            headers: { Authorization: `Bearer ${token}` },
        });
        return { error: false, res: res };
    } catch (e) {
       //console.log"e..", e)
        const err = { error: true, data: e?.Error };
        return err;
    }
};

export const getAssignedLaunchForStudentById = async (token,data) => {
    try {
        const res = await axios.get(`${baseUrl}/student/launchtrek/fetchDataStudentBtId?id=${data}`,{
            headers: { Authorization: `Bearer ${token}` },
        });
        return { error: false, res: res };
    } catch (e) {
       //console.log"e..", e)
        const err = { error: true, data: e?.Error };
        return err;
    }
};